import { render, staticRenderFns } from "./gundong.vue?vue&type=template&id=4c218e11&scoped=true"
import script from "./gundong.vue?vue&type=script&lang=js"
export * from "./gundong.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c218e11",
  null
  
)

export default component.exports